var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isAvailable
      ? _c(
          "div",
          [
            _c("L10n", {
              attrs: {
                text: "You need to set an email address in 'Personal info' first.",
              },
            }),
          ],
          1
        )
      : _vm.loading
      ? _c("div", [_c("span", { staticClass: "icon-loading-small" })])
      : _c("div", [
          _vm.state === _vm.states.DISABLED
            ? _c("p", [
                _vm.ErrorDetected === true
                  ? _c(
                      "span",
                      [
                        _c("L10n", {
                          attrs: {
                            text: "Could not send a verification code via email. An Admin must set this up first.",
                          },
                        }),
                      ],
                      1
                    )
                  : _c("span", [
                      _c(
                        "button",
                        { on: { click: _vm.enable } },
                        [
                          _c("L10n", {
                            attrs: {
                              text: "Enable Two-Factor Authentication via Email",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state === _vm.states.CREATED
            ? _c("p", [
                _vm.ErrorDetected === true
                  ? _c(
                      "span",
                      [
                        _c("L10n", {
                          attrs: {
                            text: "The entered code does not match that sent to {emailAddress}.",
                            options: { emailAddress: _vm.emailAddress },
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c("L10n", {
                          attrs: {
                            text: "A code has been sent to {emailAddress}.",
                            options: { emailAddress: _vm.emailAddress },
                          },
                        }),
                      ],
                      1
                    ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmationCode,
                      expression: "confirmationCode",
                    },
                  ],
                  domProps: { value: _vm.confirmationCode },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.confirmationCode = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  { on: { click: _vm.confirm } },
                  [_c("L10n", { attrs: { text: "Verify code" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { on: { click: _vm.disable } },
                  [_c("L10n", { attrs: { text: "Cancel activation" } })],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state === _vm.states.ENABLED
            ? _c(
                "p",
                [
                  _c("L10n", {
                    attrs: {
                      text: "Two-Factor Authentication via Email is enabled. Codes are sent to {emailAddress}.",
                      options: { emailAddress: _vm.emailAddress },
                    },
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "button",
                    { on: { click: _vm.disable } },
                    [
                      _c("L10n", {
                        attrs: {
                          text: "Disable Two-Factor Authentication via Email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }